import React from "react";
import "./style.css";
import Accordian from "../Accordian";
import MainHeading from "../Utils/mainHeading";
import { useTranslation } from "react-i18next";

export default function FAQs() {
    const { t ,i18n} = useTranslation();
const faqItems = t("faq.items", { returnObjects: true });
    
    return(
        <div className="FAQs_section">
            <MainHeading align={"center"} width={"50%"} content1={t("faq.title")}  margin={"0 0 40px 0"} content2={t("faq.description")} />
            <div className="FAQs">
                {
                    faqItems.map((item,index)=>(
                        <Accordian key={index} question={item.question} answer={item.answer} />
                    ))
                }
            </div>
        </div>
    )
}